module.exports = __webpack_public_path__ + "static/media/logo_instagram.b7faf2fb.png";